import { css } from '@emotion/react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { useFundIdField } from '../../../../../../data-fields/CommonFields';
import { FieldSelect } from '../../../../../Form/Display/FieldSelect';
import { useUpdateSelectedView } from '../../../../../../pages/PortfolioOverview/hooks/useViewActions';
import { PermissionService } from '../../../../../../services/PermissionService';
import { PermissionKey } from '../../../../../../services/PermissionAndRolesKeys';

const filterCss = css`
  min-width: 12rem;
`;

export const fundFilterStateAtom = atom<number | null>(null);

export function FundFilterSingleSelect() {
  const fundId = useAtomValue(fundFilterStateAtom);
  const saveFundIdToView = useSaveFundIdToView();
  const disabled = !PermissionService.get().hasPermission(PermissionKey.canWriteMultiperiod);

  const fundFormField = useFundIdField({
    disabled,
    placeholder: 'Filter by fund',
    rendererMeta: {
      enableGrouping: true,
    },
  });

  const formProps = useMemo(() => {
    return {
      value: fundId,
      onChange: saveFundIdToView,
    } as ControllerRenderProps;
  }, [fundId, saveFundIdToView]);

  return (
    <div css={filterCss}>
      <FieldSelect formField={fundFormField} formProps={formProps} />
    </div>
  );
}

function useSaveFundIdToView() {
  const setFundId = useSetAtom(fundFilterStateAtom);
  const updateSelectedView = useUpdateSelectedView();

  return useCallback(
    (fundId: number | null) => {
      setFundId(fundId);
      updateSelectedView({ fundId });
    },
    [setFundId, updateSelectedView]
  );
}
